import { ExtraPayCompare } from "../ExtraPayCompare";
import { FreightGroupItemCompare } from "../FreightGroupItemCompare";
import { HandlingRequirementsCompare } from "../HandlingRequirementsCompare";
import { OtherChargeCompare } from "../OtherChargeCompare";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCompareOrder extends Layout {
    buttonDeselectAll: Button;
    buttonSelectAll: Button;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    labelAddStops: Label;
    labelNoChangesFound: Label;
    layoutExtraPayCompare: ExtraPayCompare;
    layoutFreightGroupItemChange: FreightGroupItemCompare;
    layoutHandlingRequirementChange: HandlingRequirementsCompare;
    layoutOtherChargeCompare: OtherChargeCompare;
    panelExtraPay: Panel;
    panelFreightGroupItems: Panel;
    panelHandlingRequirements: Panel;
    panelMovementChanges: Panel;
    panelNoChangesFound: Panel;
    panelOrderChanges: Panel;
    panelOtherCharges: Panel;
    panelStopAdd: Panel;
    panelStopChanges: Panel;
    panelStopRemove: Panel;
    sourceCompareGroup: DataSource;
    sourceEdiCompareItem: DataSource;
    sourceEdiCompareItemMovement: DataSource;
    sourceEdiCompareStopAdd: DataSource;
    sourceEdiCompareStopDelete: DataSource;
    tabAccessorials: Tab;
    tabExtraPay: Tab;
    tabFreightGroupItems: Tab;
    tabMovement: Tab;
    tabNewStops: Tab;
    tabOrderChanges: Tab;
    tabOtherCharges: Tab;
    tabRemovedStops: Tab;
    tabStopChanges: Tab;
    tableMovementChanges: Table;
    tableOrderChanges: Table;
    tableStopAdd: Table;
    tableStopChanges: Table;
    tableStopRemove: Table;
    tabsetCompare: Tabset;
}
